import './ArrowButtonPop.css';

import React from 'react';
import classname from '@search/classname/src';

import { ArrowButtonPair } from './ArrowButtonPair';

const cn = classname.bind(null, 'ArrowButtonPop');

export function ArrowButtonPop(p: React.ComponentProps<typeof ArrowButtonPair>) {
    return (
        <div className={cn(null, { left: p.isLeftEdge, right: p.isRightEdge })}>
            <ArrowButtonPair {...p} />
        </div>
    );
}
